import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable()
export class UploadService {
  constructor(private http: HttpService) {}

  /**
   * Uploads a single file to the backend S3 helper.
   * Uses a fallback folder when no formId is provided so the route is always valid.
   */
  uploadFile(file: File, formId?: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    const targetFormId = (formId || 'general').trim() || 'general';
    const safeFormId = encodeURIComponent(targetFormId);

    return this.http.post(`upload/${safeFormId}`, formData, true);
  }

  /**
   * Requests the backend to fetch a public URL and return its base64 representation.
   */
  getBase64FromUrl(url: string): Observable<any> {
    return this.http.post('file/base64', { data_url: url });
  }

  /**
   * Procesa un CSV de transferencias y devuelve el archivo bancario + lot_id.
   */
  uploadTransfers(file: File, bankLayout: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('bank_layout', bankLayout || 'PICHINCHA');

    return this.http.post('upload', formData, true);
  }

  /**
   * Busca información de un lote por su lot_id.
   */
  getBatchByLotId(lotId: string): Observable<any> {
    return this.http.get(`upload/batch/${lotId}`);
  }

  /**
   * Actualiza el status de una transacción.
   */
  updateTransactionStatus(
    transactionId: number,
    status: string,
  ): Observable<any> {
    return this.http.patch(`cashout/${transactionId}`, { status });
  }

  /**
   * Sube un archivo adjunto (imagen o PDF) para una transacción.
   */
  uploadTransactionAttachment(
    transactionId: number,
    file: File,
  ): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(
      `upload/transaction/${transactionId}/attachment`,
      formData,
      true,
    );
  }

  /**
   * Downloads a file from a remote URL via backend proxy to avoid CORS.
   */
  downloadFileFromUrl(url: string): Observable<HttpResponse<Blob>> {
    return this.http.postBlob('file/download', { url });
  }
}
